import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { handleError } from "../../utils/handleError";

const initialState = {
	isLoading: true,
	error: null,
	message: null,
	HomePageContent: null,
};

const homePageSlice = createSlice({
	name: "homePage",
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
		clearMessage: (state) => {
			state.message = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchHomePageContent.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchHomePageContent.fulfilled, (state, action) => {
				state.isLoading = false;
				state.HomePageContent = action.payload?.homePageData;
				state.message = action.payload?.message || null;
			})
			.addCase(fetchHomePageContent.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to load home page content";
			})

			.addCase(updateHomePageContent.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(updateHomePageContent.fulfilled, (state, action) => {
				state.isLoading = false;
				state.HomePageContent = action.payload?.homePageData;
				state.message = action.payload?.message || null;
			})
			.addCase(updateHomePageContent.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload?.message || "Failed to update home page content";
			});
	},
});

// Thunks
export const fetchHomePageContent = createAsyncThunk(
	"homePage/fetchAll",
	async (_, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get("/homepage");
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

export const updateHomePageContent = createAsyncThunk(
	"homePage/update",
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.patch("/homepage/update-home-page", data);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

export const { clearError, clearMessage } = homePageSlice.actions;
export default homePageSlice.reducer;
